var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 160,
    viewBox: "0 0 161 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 160,
    height: 160,
    rx: 80,
    fill: "#DCCCFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.5361 38.5122C69.4756 38.5122 61.3199 46.6678 61.3199 56.7284C61.3199 66.7889 69.4756 74.9446 79.5361 74.9446C89.5967 74.9446 97.7523 66.7889 97.7523 56.7284C97.7523 46.6678 89.5967 38.5122 79.5361 38.5122ZM58.3313 56.7284C58.3313 45.0173 67.825 35.5236 79.5361 35.5236C91.2472 35.5236 100.741 45.0173 100.741 56.7284C100.741 68.4395 91.2472 77.9332 79.5361 77.9332C67.825 77.9332 58.3313 68.4395 58.3313 56.7284Z",
    fill: "#5200FF",
    stroke: "#5200FF",
    strokeWidth: 1.92771
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7605 121.386H111.239V113.66C111.239 103.103 105.727 93.8733 97.5105 88.8682C96.6579 88.3488 96.4485 87.1391 97.1281 86.3962C97.5851 85.8968 98.3118 85.7718 98.8869 86.1178C108.066 91.6401 114.235 101.907 114.235 113.66V121.459C114.235 123.126 112.926 124.476 111.311 124.476H49.6892C48.0742 124.476 46.765 123.126 46.765 121.459V113.66C46.765 101.907 52.9337 91.6401 62.113 86.1178C62.6881 85.7718 63.4148 85.8968 63.8718 86.3962C64.5514 87.1391 64.342 88.3488 63.4894 88.8682C55.2725 93.8733 49.7605 103.103 49.7605 113.66V121.386Z",
    fill: "#5200FF",
    stroke: "#5200FF",
    strokeWidth: 1.92771
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPhoto);
export default __webpack_public_path__ + "static/media/no-photo.27eee0cf04133a6faa79925c6bf31dde.svg";
export { ForwardRef as ReactComponent };